<app-loading></app-loading>
<app-menu></app-menu>
<div class="body">
  <router-outlet></router-outlet>
</div>
